import React from 'react';
import jsPDF from 'jspdf';
import imgData from '../../../Assest/kk.png'

const DownloadAddWork = ({ row, mat, ques, file, isans }) => {

  const generatePDF = () => {


    const anskey = []
    let temp = 0;
    mat.map((i) => {
      i.map((j) => {
        temp += j;
      })
      anskey.push(temp)
      temp = 0;
    })


    const doc = new jsPDF("p", "pt");
    doc.setDrawColor(0, 0, 0); // Set the border color to black
    doc.setLineWidth(1); // Set the border thickness
    doc.addImage(imgData, 'PNG', 20, 20, 500, 500);
    const cellWidth = 50; // Width of each cell
    const cellHeight = 22; // Height of each cell
    const xStart = 40; // Starting x position
    let tableSpacing = 50; // Space between tables
    let yStart = 80; // Initial starting y position
    doc.addFont('caveat');
    let questionCount = 0;
    const questionsPerTable = 10; // Limit to 10 questions per table
    let tablesPerPage = 4; // Limit to 3 tables per page

    if (row < 4) {
      tablesPerPage = 5
    }

    if (row == 6) {
      // tablesPerPage = 4;
      tableSpacing = 36; // Space between tables
    }
    if (row > 6) {
      tablesPerPage = 3
      // tableSpacing = 30
    }
    if (row > 8) {
      tablesPerPage = 2

    }

    doc.text(xStart, 50, "WorkSheet : ")
    doc.text(380, 50, "Date :  ___/___/____")
    doc.setFontSize(12);



    // Loop through all questions and create tables
    for (let tableIndex = 0; tableIndex < Math.ceil(ques / questionsPerTable); tableIndex++) {
      // Calculate the question range for this table
      const startQuestion = tableIndex * questionsPerTable;
      const endQuestion = Math.min(startQuestion + questionsPerTable, ques);

      // Add headers (1 to 10 or less if fewer questions)
      for (let i = startQuestion; i < endQuestion; i++) {
        const x = xStart + (i - startQuestion) * cellWidth;

        // Yellow background for header
        // doc.rect(x, yStart, cellWidth, cellHeight, 'F'); // Draw filled rectangle
        // Set fill color to lilac (RGB: 200, 162, 200)
        doc.setFillColor(204, 192, 212);
        doc.rect(x, yStart, cellWidth, cellHeight, 'F'); // Draw filled rectangle
        // Draw the border for the header
        doc.rect(x, yStart, cellWidth, cellHeight);

        // Add header number
        doc.text(
          String(i + 1), // Header number (1 to ques)
          x + cellWidth / 2, // Center horizontally
          yStart + cellHeight / 2 + 5, // Center vertically
          { align: "center" }
        );
      }

      yStart += cellHeight; // Move yStart down to start table rows
      for (let i = 0; i <= row; i++) {
        for (let q = startQuestion; q < endQuestion; q++) {
          const x = xStart + (q - startQuestion) * cellWidth;
          const y = yStart + i * cellHeight;

          // Draw [the cell
          // if(q==9){
          doc.rect(x, y, 0, cellHeight);
          doc.rect(x + 50, y, 0, cellHeight);

          // }
          if (i == row) {
            doc.rect(x, y, cellWidth, cellHeight);

            if(isans){   
             doc.text(
              String(anskey[q]),
              x + 15 + cellWidth / 2, // Center horizontally
              y + cellHeight / 2 + 5, // Center vertically
              { align: "right" }
            );}

          }
          // Add the number inside the cell for the main rows
          const value = mat[q][i]; // Get the value for the current question and row
          if (value !== undefined) {
            doc.text(
              String(value),
              x + 15 + cellWidth / 2, // Center horizontally
              y + cellHeight / 2 + 5, // Center vertically
              { align: "right" }
            );
          }
        }


      }


      const totalHeight = yStart + row * cellHeight;
      yStart = totalHeight + tableSpacing;

      // Add a new page if necessary
      if ((tableIndex + 1) % tablesPerPage === 0 && tableIndex + 1 < Math.ceil(ques / questionsPerTable)) {
        doc.addPage();
        yStart = 60; // Reset yStart for the new page
        doc.addImage(imgData, 'PNG', 20, 20, 500, 500);
      }
      questionCount ++;
    }

    // Determine the filename based on whether answers are included
    const fl = isans ? `${file} - With Answer - ` : `${file} - Question - `;

    // Save the PDF
    doc.save(fl + '.pdf');
  };

  return (
    <div>
      <button className="bt-purple" onClick={generatePDF} type="primary">
        {isans ? "Download Question + Answer Pdf" : "Download Question Pdf"}
      </button>
    </div>
  );
};

export default DownloadAddWork;